/** Aligns with `21m-event-service` `livekit-identity.helpers.ts` (participant identity ↔ Mongo player id). */

const MEDIA_AGENT_LIVEKIT_IDENTITY_PREFIX = 'media-agent-';
/** Remote speaker consoles join as `remote-speaker-{playerId}-{sessionEpoch}`. */
const REMOTE_SPEAKER_LIVEKIT_IDENTITY = /^remote-speaker-(.+)-\d+$/;

export function playerIdFromLivekitIdentity(identity: string): string {
  if (identity.startsWith(MEDIA_AGENT_LIVEKIT_IDENTITY_PREFIX)) {
    return identity.slice(MEDIA_AGENT_LIVEKIT_IDENTITY_PREFIX.length);
  }
  const remoteSpeaker = REMOTE_SPEAKER_LIVEKIT_IDENTITY.exec(identity);
  if (remoteSpeaker) {
    return remoteSpeaker[1]!;
  }
  if (identity.includes(':')) {
    return identity.split(':')[1]!;
  }
  return identity;
}

/** Whether a LiveKit identity refers to the given player id (Mongo ObjectId string). */
export function livekitIdentityMatchesPlayerId(identity: string, playerId: string): boolean {
  return playerIdFromLivekitIdentity(identity) === playerId;
}
